import { render, staticRenderFns } from "./ReporteMoldeParos.vue?vue&type=template&id=24235e95&scoped=true&"
import script from "./ReporteMoldeParos.vue?vue&type=script&lang=js&"
export * from "./ReporteMoldeParos.vue?vue&type=script&lang=js&"
import style0 from "./ReporteMoldeParos.vue?vue&type=style&index=0&id=24235e95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24235e95",
  null
  
)

export default component.exports